<template>
  <span v-if="termsUrl" class="terms-and-conditions">
    <a :href="termsUrl" target="_blank" rel="noopener noreferrer" class="terms-link">
      {{ linkText }}
    </a>
  </span>
</template>

<script setup lang="ts">
  import { computed, defineProps } from 'vue'
  import { useStore } from 'vuex'
  import localeToConditionsUrl from '@/config/termsAndConditions'
  import yoonlyDomainToConditionsUrl from '@/config/termsAndConditions'
  import YoonlyService from '@/services/YoonlyService'

  // Define the props
  const props = defineProps<{
    linkText?: string // Allow custom link text, but don't provide default since translations should come from parent
    customUrl?: string // Optional custom URL to override the default locale-based URL
  }>()

  const store = useStore()
  const isYoonly = new YoonlyService().isYoonly

  // Get current locale from store
  const currentLocale = computed(() => {
    const locale = store.getters.getLocale || 'en-US'

    // Convert from hyphen format (fr-FR) to underscore format (fr_FR)
    const underscoreLocale = locale.replace(/-/g, '_')
    return underscoreLocale
  })

  // Get the terms and conditions URL for current locale, or use custom URL if provided
  const termsUrl = computed(() => {
    if (isYoonly) {
      return yoonlyDomainToConditionsUrl[window.location.hostname] || yoonlyDomainToConditionsUrl['www.yoonly.eu']
    }

    if (props.customUrl) {
      return props.customUrl
    }

    return localeToConditionsUrl[currentLocale.value] || localeToConditionsUrl['en_US']
  })
</script>

<style scoped>
  .terms-link {
    color: var(--primary-blue, #007bff);
    text-decoration: underline;
    font-size: inherit; /* Inherit font size from parent */
    font-weight: inherit; /* Inherit font weight from parent */
  }

  .terms-link:hover {
    color: var(--primary-blue-dark, #0056b3);
    text-decoration: underline;
  }
</style> 